import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const CollectionDocumentation = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Collection Documentation</strong>
                <br />
                <br />
                <p>
                    HawkClient allows you to create rich, well-structured documentation for your API collections using <strong>Markdown</strong>. This makes it easy to add descriptions, usage notes, and team communication directly alongside your requests.
                </p>
                <p>
                    The documentation is displayed within the collection view, making it accessible and visible to anyone exploring the API.
                </p>
            </Typography>
            <img
                src="/docs/CollectionDoc.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />
            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <p>
                    To modify the documentation, simply click on the <strong>Edit Mode</strong> button. This opens an inline editor where you can write or update content using Markdown syntax.
                </p>
                <p>
                    This feature is especially useful for collaborative teams, helping maintain clarity around the purpose, structure, and expected behavior of API collections.
                </p>
            </Typography>
            <img
                src="/docs/CollectionDocEdit.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />
        </Box>
    )
};

export default CollectionDocumentation;